import { NextRequest, NextResponse } from 'next/server'
import { AdminApiError, requireAdminForApi } from '@/lib/admin-auth'
import { listSubscriptionRequests } from '@/lib/admin-data'

export async function GET(request: NextRequest) {
  try {
    await requireAdminForApi()

    const { searchParams } = new URL(request.url)
    const data = await listSubscriptionRequests({
      page: Number(searchParams.get('page') || '1'),
      pageSize: Number(searchParams.get('pageSize') || '20'),
      status: searchParams.get('status') || 'pending',
      search: searchParams.get('search') || '',
    })

    return NextResponse.json(data)
  } catch (error) {
    if (error instanceof AdminApiError) {
      return NextResponse.json({ error: error.message }, { status: error.status })
    }

    console.error(error)
    return NextResponse.json({ error: 'Unexpected error' }, { status: 500 })
  }
}
